// Every table document carries its tableType, 'timeSeries' or 'raw'
// (common/tables/table_types.py refuses any other value and an absent one), so it
// is read as it is stored.
export const isRawTable = (t) => t?.tableType === 'raw';
export const isTimeSeriesTable = (t) => t?.tableType === 'timeSeries';
export const isExternalTable = (t) => t?.storage === 'external';
export const externalAccessMode = (t) => (isExternalTable(t) ? (t.access || 'live') : null);
